import type { IDisposable } from '.'

export class DisposableBase implements IDisposable {
    protected readonly _disposers: (() => void)[] = []

    dispose() {
        for (const disposer of this._disposers) {
            disposer()
        }

        this._disposers.length = 0
    }
}
